import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery, pyrotchBaseUrl } from "../axios/AxiosInstance";

export const PushNotificationApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: pyrotchBaseUrl + "v1/",
  }),
  reducerPath: "pushNotificationApi",
  endpoints: (build) => ({
    registerPushToken: build.mutation<void, { token: string; platform: string }>({
      query: (data) => ({
        url: "push/register",
        method: "POST",
        data,
      }),
    }),
    unregisterPushToken: build.mutation<void, { token: string }>({
      query: ({ token }) => ({
        url: `push/unregister?token=${encodeURIComponent(token)}`,
        method: "POST",
      }),
    }),
  }),
});

export const { useRegisterPushTokenMutation, useUnregisterPushTokenMutation } = PushNotificationApi;
